import { showFailToast } from 'vant'
import { multiply, add, subtract } from '@/utils/math'

/**
 * 订单金额计算 composable（H5版）
 * @param {Ref} form - 订单表单
 * @param {Map} maxReductionAmount - 各授课类型最大减免金额
 * @param {Map} maxGiftHour - 各授课类型最大赠送课时
 * @param {Function} onCourseDataUpdated - 课程数据更新回调
 */
export function useOrderAmount(form, maxReductionAmount, maxGiftHour, onCourseDataUpdated) {
  /** 更新金额数据 */
  const refreshAmount = () => {
    form.value.studyCourseList?.forEach(course => {
      course.realPrice = +(course.coursePay * course.discount / 100 - course.reductionAmount).toFixed(2)
    })
    form.value.courseAmount = parseFloat(
      (form.value.studyCourseList?.reduce((acc, cur) => acc + cur.coursePay, 0)).toFixed(2)
    )
    form.value.shouldPay = parseFloat(
      (form.value.studyCourseList?.reduce((acc, cur) => acc + cur.realPrice, 0)).toFixed(2)
    )
    form.value.preferentialAmount = parseFloat((form.value.courseAmount - form.value.shouldPay).toFixed(2))
    form.value.shouldPay = form.value.shouldPay + Number(form.value.textBookAmount || 0) + Number(form.value.filingAmount || 0)
    realPayChange()
  }

  /** 支付金额变更 */
  const realPayChange = () => {
    form.value.realPay = form.value.payList?.reduce((acc, cur) => add(acc, cur.payAmount, 2), 0) || 0
    if (form.value.realPay > form.value.shouldPay) {
      form.value.isOvercharging = 1
      form.value.overchargingAmount = subtract(form.value.realPay, form.value.shouldPay, 2)
      form.value.arrearage = 0
    } else if (form.value.realPay < form.value.shouldPay) {
      form.value.isOvercharging = 0
      form.value.overchargingAmount = 0
      form.value.arrearage = subtract(form.value.shouldPay, form.value.realPay, 2)
    } else {
      form.value.isOvercharging = 0
      form.value.overchargingAmount = 0
      form.value.arrearage = 0
    }
  }

  /** 课时数量变更 */
  const buyNumbersChange = (row) => {
    row.buyClassHourCount = row.buyNumbers * row.classHourCount
    row.coursePay = multiply(row.buyNumbers, row.totalPrice, 2)
    if (!form.value.isSpecialDiscount) {
      row.editGiftClassHourCount = false
      if (!form.value.selectVoucher || form.value.selectVoucher.length === 0) {
        row.editReductionAmount = false
      }
    }
    updateOrderCourseData()
  }

  /** 更新订单数据 */
  const updateOrderCourseData = () => {
    form.value.classHourTotal = form.value.studyCourseList?.reduce(
      (acc, cur) => acc + parseFloat(cur.buyClassHourCount),
      0
    )
    if (onCourseDataUpdated) onCourseDataUpdated()
    refreshAmount()
  }

  /** 优惠金额修改事件 */
  const reductionAmountChange = (row) => {
    const reductionAmount = form.value.studyCourseList?.reduce((acc, cur) => {
      return cur.teachingType === row.teachingType ? acc + (cur.reductionAmount || 0) : acc
    }, 0)
    if (!form.value.isSpecialDiscount && reductionAmount > maxReductionAmount.get(row.teachingType)) {
      row.reductionAmount = 0
      showFailToast('不能超过最大减免金额')
    }
    refreshAmount()
  }

  /** 折扣修改事件 */
  const discountChange = () => {
    refreshAmount()
  }

  /** 赠送课时变更 */
  const giftClassHourCountChange = (row) => {
    const giftHourCountTotal = form.value.studyCourseList?.reduce((acc, cur) => {
      return cur.teachingType === row.teachingType ? acc + (cur.giftClassHourCount || 0) : acc
    }, 0)
    if (!form.value.isSpecialDiscount && giftHourCountTotal > maxGiftHour.get(row.teachingType)) {
      row.giftClassHourCount = 0
      showFailToast('不能超过最大赠送课时')
    }
    refreshAmount()
  }

  return {
    refreshAmount,
    realPayChange,
    buyNumbersChange,
    updateOrderCourseData,
    reductionAmountChange,
    discountChange,
    giftClassHourCountChange
  }
}
